export default "__VITE_PUBLIC_ASSET__7304f715__"